"use client";
import { Popover } from "@headlessui/react";
import React, { useContext, useState } from "react";
import { usePopper } from "react-popper";
import { QRCode } from "react-qrcode-logo";

const Seed = ({ seed }: { seed: string }) => {
  const [popperElement, setPopperElement] = useState<any>();
  const [referenceElement, setReferenceElement] = useState<any>();
  const { styles, attributes } = usePopper(referenceElement, popperElement, {
    placement: "top",
    modifiers: [
      {
        name: "offset",
        options: {
          offset: [-8, 0],
        },
      },
    ],
  });

  return (
    <Popover>
      <span className="absolute bottom-3 right-3 z-10 text-3xl select-none  flex flex-row items-baseline">
        <Popover.Panel
          ref={setPopperElement}
          style={{ ...styles.popper }}
          {...attributes.popper}
        >
          <div className="border-white border-4 p-1 pb-2 flex flex-col justify-between items-center rounded-md text-xs font-Bebas bg-transparent">
            <QRCode
              ecLevel="L"
              value={`https://speedtracer.xyz?s=${seed}`}
              size={72}
              quietZone={6}
            />
            <a className="my-1" href={`https://speedtracer.xyz?s=${seed}`}>
              spdtrcr.com/{seed}
            </a>
          </div>
        </Popover.Panel>
        <Popover.Button>
          <div
            ref={setReferenceElement}
            className="ml-0 global-shadow text-3xl text-white font-Bebas flex flex-row items-baseline "
          >
            <span className="text-xl">#</span>
            {seed}
          </div>
        </Popover.Button>
      </span>
    </Popover>
  );
};

export default Seed;
